import type { FaireProductEntity } from "../../entity_types/product";

export const atc_toast_10: FaireProductEntity = {
  token: "atc_toast_10",
  type: "product",
  name: "Botanical Diffuser Oil",
  brandName: "Vitruvi",
  imageUrl: "",
  priceDollars: 22.0,
  msrpDollars: 44.0,
  description: "Migrated search/ATC mock product",
  tags: ["search", "prototype"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
